












import Vue from 'vue'
import {mapActions} from 'vuex'
import GoogleSignup from '@/components/all/GoogleSignup.vue'
import FacebookSignup from '@/components/all/FacebookSignup.vue'

export default Vue.extend({
    components: {
        GoogleSignup,
        FacebookSignup
    },
    methods: {
        ...mapActions('modal', ['showModal'])
    }
})
